// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3dy96","approved":"Status_approved__1t8bg","rejected":"Status_rejected__3CsiI","expired":"Status_expired__1izXI","label":"Status_label__3t925"};